<div class="row" *ngIf="garageVisit">
  <div class="col-12 ">
    <div class="menu-box-visit m-2 p-2">
      <div class="menu-box-visit-text p-1">
        Potwierdzenie rezerwacji umówienia
      </div>
      <div class="menu-box-visit-text p-1">
        {{ garageVisit.Date| date:'yyyy.MM.dd  HH:mm'}}
      </div>
      <div class="menu-box-visit-text p-1">
        {{ garageVisit.Garage.Name}}
      </div>
      <div class="menu-box-visit-text p-1">
        {{ garageVisit.Garage.Street}}
      </div>
      <div class="menu-box-visit-text p-1" *ngIf="garageVisit.Garage.Telephone">
        tel: {{ garageVisit.Garage.Telephone}}
      </div>
    </div>
  </div>
</div>




<ng-container *ngIf="!garageVisit">
  <div class="container z-index-master">
    <div class="row align-items-center">
      <div class="col-md-12">
        <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
